console.log("----------------");
console.log("Portal Eurofarma");
console.log("Powered by LQDI SapphireCMS");
console.log("Copyright (c) Technology by LQDI.net - 2020");
console.log("----------------");

require('bootstrap');

import Vue from 'vue'
import Lang from './admin/services/Lang';
import './frontend/services/SpotifyService';
window.$ = window.jQuery = require('jquery');

window.Vue = Vue;
window.Lang = Lang;

import VueMask from 'v-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import money from 'v-money';
import BootstrapVue from "bootstrap-vue";
import VueLazyload from "vue-lazyload";
import VueAudio from 'vue-audio-better'
window.FormValidationCtrl = require('./frontend/services/FormValidationCtrl');

Vue.use(VueMask);
Vue.use(createNumberMask);
Vue.use(BootstrapVue);
Vue.use(FormValidationCtrl);

Vue.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1
});

Vue.use(VueAudio);
Vue.use(Lang.plugin);
Vue.use(money, {precision: 2})

window.createNumberMask = createNumberMask;
window.axios = require('axios');

Vue.prototype.$eventHub = new Vue();

Vue.component('accordeon', require('./frontend/components/Accordeon').default);
Vue.component('article-slider', require('./frontend/components/ArticleSlider').default);
Vue.component('featured-products-slider', require('./frontend/components/FeaturedProductsSlider').default);
Vue.component('filterable-table', require('./frontend/components/FilterableTable').default);
Vue.component('header-slider', require('./frontend/components/HeaderSlider').default);
Vue.component('content-carousel', require('./frontend/components/ContentCarousel').default);
Vue.component('histories-slider', require('./frontend/components/HistoriesSlide').default);
Vue.component('image-gallery', require('./frontend/components/ImageGallery').default);
Vue.component('widget-quiz', require('./frontend/components/QuizWidget').default);
Vue.component('truth-or-myth', require('./frontend/components/TruthOrMyth').default);
Vue.component('timeline', require('./frontend/components/Timeline').default);
Vue.component('youtube-player', require('./frontend/components/YoutubePlayer').default);
Vue.component('pages-table', require('./frontend/components/PagesTable').default);
Vue.component('taxonomy-pages-table', require('./frontend/components/TaxonomyPagesTable').default);
Vue.component('podcasts-pages-table', require('./frontend/components/PodcastsPagesTable').default);
Vue.component('form-builder-input', require('./frontend/components/FormBuilderInput').default);
Vue.component('content-collapse', require('./frontend/components/ContentCollapse').default);
Vue.component('sort-table-component-ctrl', require('./frontend/components/SortTableComponentCtrl').default);

// Borrowed from admin - TODO: move these to /shared instead
Vue.component('loading-feedback', require('./admin/components/LoadingFeedback').default);
Vue.component('datetime-picker', require('./admin/components/DateTimePicker').default);

Vue.component('latest-posts', require('./frontend/components/LatestPosts').default);
Vue.component('carousel-posts', require('./frontend/components/CarouselPosts').default);
Vue.component('featured-posts', require('./frontend/components/FeaturedPosts').default);
Vue.component('featured-products', require('./frontend/components/FeaturedProducts').default);
Vue.component('recommended-content', require('./frontend/components/RecommendedContent').default);
Vue.component('form-submission-ctrl', require('./frontend/components/FormSubmissionCtrl').default);
Vue.component('waitlist-submission-ctrl', require('./frontend/components/WaitlistSubmissionCtrl').default);
Vue.component('tabs', require('./frontend/components/Tabs').default);
Vue.component('search-results-ctrl', require('./frontend/components/SearchResultsCtrl').default);
Vue.component('sellers-results-ctrl', require('./frontend/components/SellersResultsCtrl').default);
Vue.component('cookie-bar-ctrl', require('./frontend/components/Cookiebar').default);
Vue.component('login-registration-ctrl', require('./frontend/components/LoginRegistrationCtrl').default);
Vue.component('product-storefront-ctrl', require('./frontend/components/ProductStorefrontCtrl').default);
Vue.component('product-sellers-ctrl', require('./frontend/components/ProductSellersCtrl').default);
Vue.component('search-autocomplete-ctrl', require('./frontend/components/SearchAutocompleteCtrl').default);
Vue.component('search-inline-filter-ctrl', require('./frontend/components/SearchInlineFilterCtrl').default);
Vue.component('product-search-results-ctrl', require('./frontend/components/ProductSearchResultsCtrl').default);
Vue.component('useful-content-ctrl', require('./frontend/components/UsefulContentCtrl').default);
Vue.component('speech-element-ctrl', require('./frontend/components/SpeechElementCtrl').default);
Vue.component('genericos-lp-ctrl', require('./frontend/components/GenericosLpCtrl').default);
Vue.component('suganon-lp-ctrl', require('./frontend/components/SuganonLpCtrl').default);
Vue.component('confirm-healthcare-ctrl', require('./frontend/components/ConfirmHealthcareCtrl').default);


Vue.component('course-enrollment-form', require('./frontend/components/CourseEnrollmentForm').default);

Vue.component('calculadora-imc', require('./frontend/components/CalculadoraIMC').default);
Vue.component('calculadora-peso-ideal', require('./frontend/components/CalculadoraPesoIdeal').default);
Vue.component('calculadora-superficie-corporea', require('./frontend/components/CalculadoraSuperficieCorporea').default);
Vue.component('calculadora-gravidez', require('./frontend/components/CalculadoraGravidez').default);
Vue.component('calculadora-risco-cardiovascular', require('./frontend/components/CalculadoraRiscoCardiovascular').default);

Vue.component('cmo-page-ctrl', require('./frontend/controllers/CmoPageCtrl').default);
Vue.component('nenedent-page-ctrl', require('./frontend/controllers/NenedentPageCtrl').default);
Vue.component('genova-page-ctrl', require('./frontend/controllers/GenovaPageCtrl').default);
Vue.component('ventures-page-ctrl', require('./frontend/controllers/VenturesPageCtrl').default);

Lang.discoverLocale();

window.app = new Vue({
    el: '#app',
    data:{
        sharedState: {
            language: 'pt-BR'
        },
    }
});
